export default __webpack_public_path__ + "static/media/login_banner.ea33f304.png";